import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Card, CardBody, CardFooter, Col, Container, Row } from "reactstrap"
import {
  deleteBatch,
  getCodeBatch,
  getCodesList,
  retryBatch,
} from "store/actions"
import CodesList from "./codesList"
import GenerateCode from "./generateCode"

const GenerateCodeScreen = ({
  history,
  getCodeBatch,
  batch,
  getCodesList,
  retryBatch,
  deleteBatch,
}) => {
  const [showCodesList, setShowCodesList] = useState(false)

  const codesListRef = useRef(null)

  useEffect(() => {
    getCodeBatch()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadcrumbTitle
            title="Generate Code"
            breadcrumbItems={[
              { title: "Dashboard" },
              { title: "Codes List", link: "/codes" },
              { title: "Generate" },
            ]}
          />
          <Row className="d-flex justify-content-end">
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Back"
                color="light"
                onClick={() => history.goBack()}
              />
            </Col>
          </Row>
          <Row className="my-3 d-flex justify-content-center">
            <Col xl={6}>
              <GenerateCode />
            </Col>
          </Row>
          <Row>
            {batch?.map(i => {
              return (
                <Col xl="3" sm="6" key={i?.id}>
                  <Card className="shadow-sm">
                    <CardBody>
                      <Row>
                        <Col xs="7">
                          <Row>
                            <Col xs="auto">
                              <label>Word: </label>
                              <span> {i?.word}</span>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="auto">
                              <label>Host codes: </label>
                              <span> {i?.hosts}</span>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="auto">
                              <label>Guest codes / host:</label>
                              <span> {i?.guest_per_host}</span>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="auto">
                              <label>Digital: </label>
                              <span> {i?.digital ? "Yes" : "No"}</span>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="auto">
                              <label>Completed: </label>
                              <span> {i?.completed ? "Yes" : "No"}</span>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs="5" className="align-self-center ">
                          <h4 style={{ textAlign: "center" }}>
                            {parseFloat(
                              (i?.progress?.processed / i?.progress.total) * 100
                            ).toFixed(2)}
                            %
                          </h4>
                        </Col>
                      </Row>
                    </CardBody>
                    <CardFooter className="bg-transparent border-top">
                      <Row className="d-flex justify-content-end">
                        <Col xs="auto">
                          <i
                            className="bx bxs-show font-size-20"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              getCodesList({
                                bch: i?.id,
                                o: "created_at",
                                od: "desc",
                                page: 1,
                              })
                              setShowCodesList(true)
                              codesListRef?.current?.scrollIntoView()
                            }}
                          />
                        </Col>
                        <Col xs="auto">
                          <i
                            className="bx bx-revision font-size-20"
                            style={{ cursor: "pointer" }}
                            onClick={() => retryBatch({ id: i?.id })}
                          />
                        </Col>
                        <Col xs="auto">
                          <i
                            className="bx bxs-trash-alt font-size-20"
                            style={{ cursor: "pointer" }}
                            onClick={() => deleteBatch({ id: i?.id })}
                          />
                        </Col>
                      </Row>
                    </CardFooter>
                  </Card>
                </Col>
              )
            })}
          </Row>
          <div ref={codesListRef}>
            {showCodesList && (
              <Row>
                <Card>
                  <CardBody>
                    <Row>
                      <Col>
                        <h5>Codes List</h5>
                      </Col>
                    </Row>
                    <CodesList />
                  </CardBody>
                </Card>
              </Row>
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  batch: state.codes.batch,
})

const mapDispatchToProps = dispatch => ({
  getCodeBatch: values => dispatch(getCodeBatch(values)),
  getCodesList: values => dispatch(getCodesList(values)),
  retryBatch: values => dispatch(retryBatch(values)),
  deleteBatch: values => dispatch(deleteBatch(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(GenerateCodeScreen))
